// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AcceptMembersPage.module.css */

/* Основные стили */
.AcceptMembersPage_acceptMembersPage__4J9Yd {
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem;
}

.AcceptMembersPage_acceptMembersPage__4J9Yd h1 {
  text-align: center;
  margin: 1.5rem 0;
  font-size: 1.5rem;
  color: #2c3e50;
}

/* Список пользователей */
.AcceptMembersPage_memberList__DPHkY {
  list-style: none;
  padding: 0;
  margin: 0;
}

.AcceptMembersPage_memberItem__oPgNC {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  margin: 0.5rem 0;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  transition: background 0.2s;
}

.AcceptMembersPage_memberItem__oPgNC:hover {
  background: #f1f3f5;
}

.AcceptMembersPage_profileBtn__EzFdB {
  padding: 0.5rem 1rem;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background 0.2s;
}

.AcceptMembersPage_profileBtn__EzFdB:hover {
  background: #2980b9;
}

/* Модальные окна */
.AcceptMembersPage_modal__LygDT {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.AcceptMembersPage_compactModalContent__tNNGH {
  background: white;
  border-radius: 8px;
  width: 95%;
  max-width: 640px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.AcceptMembersPage_modalHeader__l0S48 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #ecf0f1;
}

.AcceptMembersPage_modalHeader__l0S48 h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #2c3e50;
}

.AcceptMembersPage_closeButton__ZsOOp {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  line-height: 1;
  transition: color 0.2s ease; /* Добавлено */
}

.AcceptMembersPage_closeButton__ZsOOp:hover {
  color: #2196F3; /* Изменено на синий */
  background: none; /* Убрано зеленое выделение */
}

/* Вкладки */
.AcceptMembersPage_scrollableTabs__\\+tutW {
  border-bottom: 1px solid #ecf0f1;
  overflow-x: auto;
}

.AcceptMembersPage_tabs__NmmrA {
  display: flex;
  min-width: max-content;
  padding: 0 0.5rem;
}

.AcceptMembersPage_tab__hA\\+Sk {
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
  color: #7f8c8d;
  font-size: 0.875rem;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  transition: color 0.2s ease;
}

.AcceptMembersPage_tab__hA\\+Sk:hover {
  color: #2196F3;
  background: none;
}

.AcceptMembersPage_activeTab__Gtry8 {
  color: #2196F3;
  border-bottom: 2px solid #2196F3;
}

/* Основное содержимое */
.AcceptMembersPage_modalBody__rqq7H {
  flex: 1 1;
  padding: 1rem;
  overflow-y: auto;
}

.AcceptMembersPage_twoColumnGrid__3cv46 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.5rem;
  padding: 0.5rem 0;
}

.AcceptMembersPage_compactField__i9nju {
  padding: 0.25rem 0.5rem;
  background: #f8f9fa;
  border-radius: 4px;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.AcceptMembersPage_compactField__i9nju label {
  font-size: 0.75rem;
  color: #7f8c8d;
  margin-bottom: 0.125rem;
}

.AcceptMembersPage_compactField__i9nju div {
  font-size: 0.875rem;
  color: #2c3e50;
  word-break: break-word;
  line-height: 1.3;
}

/* Секция действий */
.AcceptMembersPage_actionsSection__fjXlI {
  padding: 1rem;
  border-top: 1px solid #ecf0f1;
  background: white;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}

.AcceptMembersPage_commentInput__VMd5j {
  width: 100%;
  height: 80px;
  padding: 0.75rem;
  border: 1px solid #bdc3c7;
  border-radius: 4px;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  resize: vertical;
}

.AcceptMembersPage_commentInput__VMd5j:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.AcceptMembersPage_actionButtons__euJwq {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

/* Кнопки действий */
.AcceptMembersPage_revisionButton__fei9E {
  background: #f1c40f;
  color: #2c3e50;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
}

.AcceptMembersPage_revisionButton__fei9E:hover{
  color: #2196F3;
  background: none;
}

.AcceptMembersPage_acceptButton__uwRAC {
  background: #27ae60;
  color: white;
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
}

.AcceptMembersPage_acceptButton__uwRAC:hover{
  color: #2196F3;
  background: none;
}

.AcceptMembersPage_rejectButton__eNWtP:hover{
color: #2196F3;
background: none;
}

.AcceptMembersPage_rejectButton__eNWtP {
  background: #e74c3c;
  color: white;
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
}

/* Модальное окно выбора организации */
.AcceptMembersPage_orgModalContent__74D6L {
  background: white;
  border-radius: 8px;
  width: 95%;
  max-width: 480px;
  padding: 1.5rem;
}

.AcceptMembersPage_orgList__iGqqb {
  margin: 1rem 0;
}

.AcceptMembersPage_orgItem__d\\+JNP {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem;
  margin: 0.5rem 0;
  border: 1px solid #bdc3c7;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.AcceptMembersPage_orgItem__d\\+JNP:hover {
  border-color: #3498db;
  background: #f5fafd;
}

.AcceptMembersPage_orgItem__d\\+JNP.AcceptMembersPage_selected__LdRsv {
  background: #e3f2fd;
  border-color: #3498db;
}

.AcceptMembersPage_orgName__AXZ44 {
  font-weight: 500;
  color: #2c3e50;
}

.AcceptMembersPage_orgLocation__gZU7L {
  color: #7f8c8d;
  font-size: 0.875rem;
}

.AcceptMembersPage_modalActions__v5utO {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin-top: 1rem;
}

.AcceptMembersPage_cancelBtn__1nRZ3 {
  background: #95a5a6;
  color: white;
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.AcceptMembersPage_confirmBtn__OUopM {
  background: #3498db;
  color: white;
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Адаптивность */
@media (max-width: 768px) {
  .AcceptMembersPage_compactModalContent__tNNGH {
    width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .AcceptMembersPage_twoColumnGrid__3cv46 {
    grid-template-columns: 1fr;
  }

  .AcceptMembersPage_modalBody__rqq7H {
    padding: 0.75rem;
  }

  .AcceptMembersPage_tab__hA\\+Sk {
    padding: 0.5rem 0.75rem;
    font-size: 0.8125rem;
  }

  .AcceptMembersPage_actionsSection__fjXlI {
    padding: 0.75rem;
  }

  .AcceptMembersPage_actionButtons__euJwq {
    flex-wrap: wrap;
    justify-content: center;
  }

  .AcceptMembersPage_actionButtons__euJwq button {
    flex: 1 1;
    min-width: 120px;
  }
}

@media (max-width: 480px) {
  .AcceptMembersPage_memberItem__oPgNC {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .AcceptMembersPage_profileBtn__EzFdB {
    width: 100%;
  }
}

.AcceptMembersPage_emptyState__hXSU9 {
  text-align: center;
  padding: 3rem 1rem;
  color: #7f8c8d;
  font-size: 1.1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  margin: 1rem 0;
}

.AcceptMembersPage_emptyState__hXSU9 p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/Members/AcceptMembersPage.module.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,2BAA2B,EAAE,cAAc;AAC7C;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;AACA,cAAc;AACd,gBAAgB;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX","sourcesContent":["/* AcceptMembersPage.module.css */\n\n/* Основные стили */\n.acceptMembersPage {\n  max-width: 800px;\n  margin: 2rem auto;\n  padding: 1rem;\n}\n\n.acceptMembersPage h1 {\n  text-align: center;\n  margin: 1.5rem 0;\n  font-size: 1.5rem;\n  color: #2c3e50;\n}\n\n/* Список пользователей */\n.memberList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.memberItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  margin: 0.5rem 0;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  transition: background 0.2s;\n}\n\n.memberItem:hover {\n  background: #f1f3f5;\n}\n\n.profileBtn {\n  padding: 0.5rem 1rem;\n  background: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: background 0.2s;\n}\n\n.profileBtn:hover {\n  background: #2980b9;\n}\n\n/* Модальные окна */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.compactModalContent {\n  background: white;\n  border-radius: 8px;\n  width: 95%;\n  max-width: 640px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid #ecf0f1;\n}\n\n.modalHeader h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #2c3e50;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  line-height: 1;\n  transition: color 0.2s ease; /* Добавлено */\n}\n\n.closeButton:hover {\n  color: #2196F3; /* Изменено на синий */\n  background: none; /* Убрано зеленое выделение */\n}\n\n/* Вкладки */\n.scrollableTabs {\n  border-bottom: 1px solid #ecf0f1;\n  overflow-x: auto;\n}\n\n.tabs {\n  display: flex;\n  min-width: max-content;\n  padding: 0 0.5rem;\n}\n\n.tab {\n  padding: 0.75rem 1rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #7f8c8d;\n  font-size: 0.875rem;\n  white-space: nowrap;\n  border-bottom: 2px solid transparent;\n  transition: color 0.2s ease;\n}\n\n.tab:hover {\n  color: #2196F3;\n  background: none;\n}\n\n.activeTab {\n  color: #2196F3;\n  border-bottom: 2px solid #2196F3;\n}\n\n/* Основное содержимое */\n.modalBody {\n  flex: 1;\n  padding: 1rem;\n  overflow-y: auto;\n}\n\n.twoColumnGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.5rem;\n  padding: 0.5rem 0;\n}\n\n.compactField {\n  padding: 0.25rem 0.5rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n  min-height: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.compactField label {\n  font-size: 0.75rem;\n  color: #7f8c8d;\n  margin-bottom: 0.125rem;\n}\n\n.compactField div {\n  font-size: 0.875rem;\n  color: #2c3e50;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n/* Секция действий */\n.actionsSection {\n  padding: 1rem;\n  border-top: 1px solid #ecf0f1;\n  background: white;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.commentInput {\n  width: 100%;\n  height: 80px;\n  padding: 0.75rem;\n  border: 1px solid #bdc3c7;\n  border-radius: 4px;\n  margin-bottom: 0.75rem;\n  font-size: 0.875rem;\n  resize: vertical;\n}\n\n.commentInput:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n.actionButtons {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n/* Кнопки действий */\n.revisionButton {\n  background: #f1c40f;\n  color: #2c3e50;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.revisionButton:hover{\n  color: #2196F3;\n  background: none;\n}\n\n.acceptButton {\n  background: #27ae60;\n  color: white;\n  padding: 0.5rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.acceptButton:hover{\n  color: #2196F3;\n  background: none;\n}\n\n.rejectButton:hover{\ncolor: #2196F3;\nbackground: none;\n}\n\n.rejectButton {\n  background: #e74c3c;\n  color: white;\n  padding: 0.5rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n/* Модальное окно выбора организации */\n.orgModalContent {\n  background: white;\n  border-radius: 8px;\n  width: 95%;\n  max-width: 480px;\n  padding: 1.5rem;\n}\n\n.orgList {\n  margin: 1rem 0;\n}\n\n.orgItem {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.75rem;\n  margin: 0.5rem 0;\n  border: 1px solid #bdc3c7;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.orgItem:hover {\n  border-color: #3498db;\n  background: #f5fafd;\n}\n\n.orgItem.selected {\n  background: #e3f2fd;\n  border-color: #3498db;\n}\n\n.orgName {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.orgLocation {\n  color: #7f8c8d;\n  font-size: 0.875rem;\n}\n\n.modalActions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n.cancelBtn {\n  background: #95a5a6;\n  color: white;\n  padding: 0.5rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.confirmBtn {\n  background: #3498db;\n  color: white;\n  padding: 0.5rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .compactModalContent {\n    width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .twoColumnGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .modalBody {\n    padding: 0.75rem;\n  }\n\n  .tab {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.8125rem;\n  }\n\n  .actionsSection {\n    padding: 0.75rem;\n  }\n\n  .actionButtons {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .actionButtons button {\n    flex: 1;\n    min-width: 120px;\n  }\n}\n\n@media (max-width: 480px) {\n  .memberItem {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .profileBtn {\n    width: 100%;\n  }\n}\n\n.emptyState {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #7f8c8d;\n  font-size: 1.1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n  margin: 1rem 0;\n}\n\n.emptyState p {\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"acceptMembersPage": `AcceptMembersPage_acceptMembersPage__4J9Yd`,
	"memberList": `AcceptMembersPage_memberList__DPHkY`,
	"memberItem": `AcceptMembersPage_memberItem__oPgNC`,
	"profileBtn": `AcceptMembersPage_profileBtn__EzFdB`,
	"modal": `AcceptMembersPage_modal__LygDT`,
	"compactModalContent": `AcceptMembersPage_compactModalContent__tNNGH`,
	"modalHeader": `AcceptMembersPage_modalHeader__l0S48`,
	"closeButton": `AcceptMembersPage_closeButton__ZsOOp`,
	"scrollableTabs": `AcceptMembersPage_scrollableTabs__+tutW`,
	"tabs": `AcceptMembersPage_tabs__NmmrA`,
	"tab": `AcceptMembersPage_tab__hA+Sk`,
	"activeTab": `AcceptMembersPage_activeTab__Gtry8`,
	"modalBody": `AcceptMembersPage_modalBody__rqq7H`,
	"twoColumnGrid": `AcceptMembersPage_twoColumnGrid__3cv46`,
	"compactField": `AcceptMembersPage_compactField__i9nju`,
	"actionsSection": `AcceptMembersPage_actionsSection__fjXlI`,
	"commentInput": `AcceptMembersPage_commentInput__VMd5j`,
	"actionButtons": `AcceptMembersPage_actionButtons__euJwq`,
	"revisionButton": `AcceptMembersPage_revisionButton__fei9E`,
	"acceptButton": `AcceptMembersPage_acceptButton__uwRAC`,
	"rejectButton": `AcceptMembersPage_rejectButton__eNWtP`,
	"orgModalContent": `AcceptMembersPage_orgModalContent__74D6L`,
	"orgList": `AcceptMembersPage_orgList__iGqqb`,
	"orgItem": `AcceptMembersPage_orgItem__d+JNP`,
	"selected": `AcceptMembersPage_selected__LdRsv`,
	"orgName": `AcceptMembersPage_orgName__AXZ44`,
	"orgLocation": `AcceptMembersPage_orgLocation__gZU7L`,
	"modalActions": `AcceptMembersPage_modalActions__v5utO`,
	"cancelBtn": `AcceptMembersPage_cancelBtn__1nRZ3`,
	"confirmBtn": `AcceptMembersPage_confirmBtn__OUopM`,
	"emptyState": `AcceptMembersPage_emptyState__hXSU9`
};
export default ___CSS_LOADER_EXPORT___;
